import React, { useState, useContext } from "react";
import Papa from "papaparse";
import * as XLSX from "xlsx";

import {
  ModalWrapper,
  InputField,
  FileLabel,
  FileInput,
  Button,
  ModalHeadText,
  InputWrapper,
  Actions,
  TooltipText,
  TooltipContainer,
  InfoIconWrapper,
  FileInputContainer,
  FileContainer,
  FileName,
  FileHeading,
} from "./styles";
import { useParams } from "react-router-dom";
import callAPI from "../../../../../../api/apiCaller";
import { Context } from "../../../../../../Store";
import Icon from "../../../../../../common/Icon";
import { validateEmail } from "../../../../../../common/utils";

const InviteModal = ({ closeModal }) => {
  const params = useParams();
  const { dispatch } = useContext(Context);
  const [emailList, setEmailList] = useState([]);
  const [fileEmails, setFileEmails] = useState([]);
  const [fileUrl, setFileUrl] = useState("");
  const [role, setRole] = useState("");
  const [isAdding, setIsAdding] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [fileName, setFileName] = useState("");

  // Handle manual email entry
  const handleEmailChange = (e) => {
    setEmailList(e.target.value.split(",").map((email) => email.trim()));
    // setEmailList(e.target.value.trim());
  };

  // Handle file URL entry
  const handleFileUrlChange = (e) => {
    setFileUrl(e.target.value.trim());
  };

  // const handleFileUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const fileName = file.name.toLowerCase();
  //   setFileName(file.name);

  //   if (fileName.endsWith(".csv")) {
  //     // Handle CSV files using PapaParse
  //     Papa.parse(file, {
  //       header: true, // Treat the first row as a header
  //       skipEmptyLines: true,
  //       complete: (result) => {
  //         const formattedData = result.data.map((row) => ({
  //           email: row.email?.trim(),
  //           joinAs: row.role?.trim(),
  //         }));
  //         setFileEmails(formattedData);
  //       },
  //     });
  //   } else if (fileName.endsWith(".xlsx") || fileName.endsWith(".xls")) {
  //     // Handle XLSX files using xlsx
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const data = new Uint8Array(e.target.result);
  //       const workbook = XLSX.read(data, { type: "array" });
  //       const sheetName = workbook.SheetNames[0];
  //       const worksheet = workbook.Sheets[sheetName];
  //       const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

  //       // Remove header row and format data
  //       const formattedData = jsonData.slice(1).map((row) => ({
  //         email: row[0]?.toString().trim(),
  //         joinAs: row[1]?.toString().trim(),
  //       }));

  //       setFileEmails(formattedData);
  //     };
  //     reader.readAsArrayBuffer(file);
  //   } else {
  //     alert("Unsupported file format. Please upload a CSV or XLSX file.");
  //   }
  // };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();

    const validColumns = ["email", "joinAs"];

    // Case-sensitive validation: Only "email" and "joinAs"
    const validateHeaders = (headers) => {
      const trimmedHeaders = headers.map((h) => h?.toString().trim());
      if (trimmedHeaders.length !== validColumns.length) return false;

      // Check for exact match regardless of order
      const sorted = [...trimmedHeaders].sort();
      return sorted[0] === "email" && sorted[1] === "joinAs";
    };

    if (fileName.endsWith(".csv")) {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          const headers = result.meta.fields || [];

          if (!validateHeaders(headers)) {
            alert(
              "CSV must contain exactly two columns: 'email' and 'joinAs' (case-sensitive)."
            );
            return;
          }

          const formattedData = result.data.map((row) => ({
            email: row.email?.trim(),
            joinAs: row.joinAs?.trim(),
          }));

          setFileEmails(formattedData);

          setFileName(file.name);
        },
        error: (err) => {
          console.error("CSV parsing error:", err);
          alert("Failed to parse CSV file.");
        },
      });
    } else if (fileName.endsWith(".xlsx") || fileName.endsWith(".xls")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const headers = jsonData[0];
        if (!validateHeaders(headers)) {
          alert(
            "Excel file must contain exactly 'email' and 'joinAs' columns (case-sensitive)."
          );
          return;
        }

        const headerIndex = {
          email: headers.indexOf("email"),
          joinAs: headers.indexOf("joinAs"),
        };

        const formattedData = jsonData.slice(1).map((row) => ({
          email: row[headerIndex.email]?.toString().trim(),
          joinAs: row[headerIndex.joinAs]?.toString().trim(),
        }));

        setFileEmails(formattedData);

        setFileName(file.name);
      };
      reader.readAsArrayBuffer(file);
    } else {
      alert("Unsupported file format. Please upload a CSV or Excel file.");
    }
  };

  // Merge manually entered emails, file data, and URL data
  const combinedParticipants = [
    ...emailList.map((email) => ({ email, joinAs: role })),
    ...fileEmails,
    ...(fileUrl ? [{ email: fileUrl, joinAs: role }] : []), // Treat file URL as an email if entered
  ];

  const addParticipants = () => {
    setIsAdding(true);
    callAPI(dispatch, "addParticipants", {
      programId: +params.selectedProgram,
      participants: combinedParticipants,
    })
      .then((res) => {
        if (res.data > 0) {
          closeModal(true, "active");
        } else {
          closeModal(true, "invites");
        }
        setIsAdding(false);
      })
      .catch((res) => {
        console.log("Error:", res);
      });
  };

  return (
    <ModalWrapper>
      <ModalHeadText>Invite Participants</ModalHeadText>
      <InputWrapper>
        <InputField type="text" onChange={handleEmailChange} />

        <select onChange={(e) => setRole(e.target.value)}>
          <option value="">Role</option>
          <option value="mentor">Mentor</option>
          <option value="mentee">Mentee</option>
        </select>
      </InputWrapper>

      <FileHeading>Import from URL</FileHeading>
      <FileInputContainer>
        <FileContainer>
          <InfoIconWrapper
            noBackground={true}
            onMouseEnter={() => setOpenTooltip(true)}
            onMouseLeave={() => setOpenTooltip(false)}
          >
            <Icon type={"info"} />
          </InfoIconWrapper>
          <InputField
            type="text"
            placeholder="Add file URL"
            value={fileUrl}
            onChange={handleFileUrlChange}
          />
        </FileContainer>
        <FileLabel htmlFor="fileUpload">Upload</FileLabel>
        <FileInput
          id="fileUpload"
          type="file"
          accept=".csv .xlsx"
          onChange={handleFileUpload}
        />
      </FileInputContainer>

      {fileName && <FileName>Selected File: {fileName}</FileName>}

      {openTooltip && (
        <TooltipContainer>
          <TooltipText>
            {/* Imported file must contain user email in column A and role (mentor
            or mentee) in column B to be successfully added. */}
            The imported file must be a CSV or Excel file (.csv, .xlsx, .xls)
            with exactly two columns: email in column A and joinAs in column B.
            The joinAs value must be either mentor or mentee.
          </TooltipText>
        </TooltipContainer>
      )}

      <Actions>
        <Button onClick={closeModal}>Cancel</Button>
        <Button
          primary
          onClick={addParticipants}
          disabled={
            isAdding ||
            combinedParticipants.length === 0 ||
            (combinedParticipants.length === 1 &&
              (!validateEmail(combinedParticipants[0]?.email) || !role))
          }
        >
          {isAdding ? "Adding..." : "Invite"}
        </Button>
      </Actions>
    </ModalWrapper>
  );
};

export default InviteModal;
